import { Box, List, ListItem, Typography } from "@mui/material";
import React from "react";
import MobileDisplayData from "../../../dumyData/DisplayInfo.json";

const MobileDetails = () => {
  return (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        {/* Mobile Display on Customer's Mobile Screen */}
      </Typography>
      <List>
        {MobileDisplayData.map((val, ind) => {
          return (
            <ListItem key={ind} sx={{ display: "block", py: "0px" }}>
              <Typography fontSize={"0.875rem"} color={"#868E96"}>
                {ind + 1}.{" "}
                <span style={{ marginLeft: "8px" }}>{val.title}</span>
              </Typography>
              {val.options.map((item, _ind) => {
                return (
                  <Typography fontSize={"0.875rem"} color={"#868E96"}>
                    . <span style={{ marginLeft: "10px" }}>{item}</span>
                  </Typography>
                );
              })}
            </ListItem>
          );
        })}
      </List>
      <Typography variant="h6" fontWeight={600}>
        Example of How It Looks
      </Typography>
      <List>
        {MobileDisplayData.map((val, ind) => {
          return (
            <ListItem key={ind} sx={{ display: "block", py: "0px" }}>
              <Typography fontSize={"0.875rem"} color={"#868E96"}>
                {ind + 1}.{" "}
                <span style={{ marginLeft: "8px" }}>{val.title}</span>
              </Typography>
              {val.options.map((item, _ind) => {
                return (
                  <Typography fontSize={"0.875rem"} color={"#868E96"}>
                    . <span style={{ marginLeft: "10px" }}>{item}</span>
                  </Typography>
                );
              })}
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default MobileDetails;
